import cx from "classnames";
import useTranslation from "../hooks/useTranslation";
import { FieldType } from "../types/feedbackFields.types";
import Message from "./Message";
import Description from "./Description";

const convertStylesStringToObject = (stringStyles?: string) => {
  if (!stringStyles) return undefined;
  return typeof stringStyles === "string"
    ? stringStyles.split(";").reduce((acc, style) => {
        const colonPosition = style.indexOf(":");

        if (colonPosition === -1) {
          return acc;
        }

        const camelCaseProperty = style
            .substr(0, colonPosition)
            .trim()
            .replace(/^-ms-/, "ms-")
            .replace(/-./g, (c) => c.substr(1).toUpperCase()),
          value = style.substr(colonPosition + 1).trim();

        return value ? { ...acc, [camelCaseProperty]: value } : acc;
      }, {})
    : {};
};

type FieldWrapperProps = {
  description?: string;
  field: FieldType;
  error?: boolean;
  children: any;
  showLabel?: boolean;
};

const typesWithoutDescription: Record<string, boolean> = {
  title: true,
  text: true,
};

const FieldWrapper = ({ field, showLabel=true, children, error }: FieldWrapperProps) => {
  const { description, text, textHtml, required, type } = field;
  const { t } = useTranslation();

  const showDescription = !typesWithoutDescription[type];

  return (
    <div
      id={`feedback_${field._id || field.name}`}
      className={cx("c-question", "c-question--type-" + type)}
      style={convertStylesStringToObject(field.containerStyle)}
    >
      {showLabel && (
        <>
          {textHtml && (
            <label
              className={cx("feedback-label", required && "is-required")}
              dangerouslySetInnerHTML={textHtml ? { __html: textHtml } : undefined}
            />
          )}
          {!textHtml && <label className={cx("feedback-label", required && "is-required")}>{text}</label>}
        </>
      )}
      {showDescription && <Description description={description} />}

      {children}
      {error && (
        <Message icon="error_outline" type="error">
          {t("required-error")}
        </Message>
      )}
    </div>
  );
};


export default FieldWrapper;
